import { Button } from "@/components/ui/button"
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog"
import React from "react"

const ConfirmationDialog = ({
  title,
  description,
  actionName,
  onConfirm,
  isOpen,
  setIsOpen,
}: {
  title: string
  description: string
  actionName: string
  onConfirm: () => void
  isOpen: boolean
  setIsOpen: (isOpen: boolean) => void
}) => {
  return (
    <Dialog open={isOpen} onOpenChange={setIsOpen}>
      <DialogContent className="rounded-[40px] py-16">
        <DialogHeader className="mb-10">
          <DialogTitle className="text-5xl font-semibold text-center mb-6">
            {title}
          </DialogTitle>
          <DialogDescription className="text-xl text-center text-textPrimary max-w-[490px] mx-auto">
            {description}
          </DialogDescription>
        </DialogHeader>
        <div className="flex flex-col gap-8 justify-center">
          <div className="text-center">
            <Button type="submit" variant="default" onClick={() => onConfirm()}>
              {actionName}
            </Button>
          </div>
          <div className="text-center">
            <DialogClose asChild>
              <button type="button" className="text-neutral-400 text-xl">
                Cancel
              </button>
            </DialogClose>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  )
}

export default ConfirmationDialog
